import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Meta Pixel `PageView` event on every client-side route change.
 *
 * The bootstrap snippet in `public/index.html` already fires the first
 * PageView at initial load; this component handles every subsequent
 * SPA navigation so the Pixel attributes the right event to the right
 * page (e.g. /quote conversions vs /services views).
 *
 * Admin routes (`/admin/*`) are skipped so business-internal navigation
 * doesn't pollute the marketing funnel data.
 */
export default function PixelTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    window.fbq("track", "PageView");
  }, [pathname]);
  return null;
}
